/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import createReactClass from 'create-react-class';

import { registerField } from 'core/forms';

import FormFieldSelect from 'uikit/forms/components/formFieldSelect';

const FormFieldSelectWithLoadOptionsContainer = createReactClass({
  getInitialState() {
    return { isLoading: true, options: [] };
  },

  componentDidMount() {
    this.loadOptions();
  },

  async loadOptions() {
    const options = await this.props.schema.selectProps?.loadOptions?.();

    if (options) {
      this.setState({ isLoading: false, options });
    }
  },

  render() {
    const { schema, ...props } = this.props;
    const { isLoading, options } = this.state;

    schema.selectProps = { ...schema.selectProps, isLoading };

    return (
      <FormFieldSelect schema={{ ...schema, options }} {...props} />
    );
  },
});

registerField(
  'SelectWithLoadOptions',
  React.memo(FormFieldSelectWithLoadOptionsContainer),
);

export default FormFieldSelectWithLoadOptionsContainer;
